import BaseServiceHttp from '../baseService'
class ObrasAutores extends BaseServiceHttp {
  constructor(id) {
    const resource = 'obras-autores'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new ObrasAutores(id)
